/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `critical` - Critical
 * `error` - Error
 * `warning` - Warning
 */
export type SeverityEnum = (typeof SeverityEnum)[keyof typeof SeverityEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SeverityEnum = {
  critical: "critical",
  error: "error",
  warning: "warning",
} as const;
